<style>
    #main_content .container.invites p{
        font-size: 1rem;
        line-height: 1.6;
    }
</style>
<template>
    <div class="container invites">
        <p>Hello {{ invite.to_name }},</p>

        <p v-if="admin_to_partner || partner_to_partner">Welcome to Go NAPSACC! It’s time to get your organization registered. You have been invited to register as a state administrator. Registration is the first step to sharing our online tools with your early care and education community and improving the health of the children you serve.</p>
        <p v-else>You are invited to register {{ invite.to_role === 'ta-consultant' ? 'a TA Consultant account' : ''  }} with Go NAPSACC, the online tool that helps early care and education programs improve the health of the children they serve.</p>
        
        <div>To register:
            <ol>
                <li>Go to {{ $basePath }}/register/invite/{{ invite.id }}</li>
                <li>Answer the questions to the registration survey.</li>
                <li>
                    You will be asked to provide a “registration code”. Please type in or copy and paste the following code exactly as it is written below:
                    <br />
                    <strong>{{ invite.code }}</strong>
                </li>
                <li>When you finish registration, you should receive a confirmation email.</li>
            </ol>
        </div>

        <p v-if="invite.to_role == 'program-user'">Please only register your child care facility once. If you own or manage more than one child care facility, please complete separate registrations for each facility.</p>
        <p v-else>Please register only once.</p>

        <p v-if="userRole == 'site-admin'">If you experience any problems while registering, please email the Go NAPSACC team (gonapsacc@unc.edu).</p>
        <p v-else>If you experience any problems while registering, please email me ({{ userEmail }}) or the Go NAPSACC team (gonapsacc@unc.edu).</p>
        
        <p v-if="userRole == 'site-admin'">
            Best,
            <br>
            Go NAPSACC Team
            <br>
            gonapsacc@unc.edu
        </p>
        <p v-else>
            Best,
            <br>
            {{ userName }}
            <br>
            {{ userEmail }}
        </p>
        <br>
        <div class="container">
            <div class="row">
                <div class="col">
                    <button class="btn btn-orange-blue" @click="sendInvite">Send Invite!</button>
                </div>
                <div class="col text-right">
                    <button class="btn btn-blue-blue" @click="deleteInvite(invite.id)">Delete Invite</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapWritableState } from 'pinia';
    import { useRegistrationCodesStore } from './store.js';

    export default {
        props: {
            userRole: {
                required: true,
                type: String
            }, 
            userName: {
                required: true,
                type: String
            }, 
            userEmail: {
                required: true,
                type: String
            },
            previewInviteId: {
                required: true,
                type: Number
            } 
        },
        data() {
            return {
                invite: {},
                recipient_options: [
                    { text: 'Program User', value: 'program-user' },
                    { text: 'TA Consultant', value: 'ta-consultant' },
                    { text: 'Partner User', value: 'partner-user' }
                ]
            }
        },

        computed: {
            admin_to_partner: function () {
                if (this.userRole == 'site-admin' && this.invite.to_role == 'partner-user') {
                    return true
                }
                return false
            },
            partner_to_partner: function () {
                if (this.userRole == 'partner-user' && this.invite.to_role == 'partner-user') {
                    return true
                }
                return false
            },
            ...mapWritableState(useRegistrationCodesStore, [
                'selectedCode',
                'bodyComponent',
                'title',
            ]),
        }, 
        watch: {
            previewInviteId: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal !== undefined)
                        this.getInvite()
                }
            },
        },
        methods: {
            getInvite() {
                axios.get('/api/invites/'+ this.previewInviteId)
                .then(function (response) {
                    this.invite = response.data.data
                }.bind(this))
                .catch(function (error) {
                    console.error(error)
                })
            },
            sendInvite() {
                axios.post('/api/invites/'+ this.previewInviteId +'/send')
                .then((response) => {
                    this.invite = {}
                    // why send payload taken from empty object above?
                    this.bodyComponent = 'Invites';
                    this.title = `Invites for code ${this.selectedCode.code}`;
                })
                .catch(error => {
                    console.error(error)
                })
            },
            deleteInvite(id) {
                axios.delete('/api/invites/'+ id)
                .then(response => {
                    this.invite = {}
                    this.$emit('inviteDeleted')
                })
                .catch(error => {
                    console.error(error)
                })
            }
        },
    }
</script>